import React, { Component } from "react";
import "./ViewSignatureModal.scss";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IShipment_GroupUI from "../../../models/IShipment_GroupUI";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import UserService from "../../../services/UserService";
import OwLabel from "../OwLabel/OwLabel";
import OwS3ImageViewer from "../OwS3ImageViewer/OwS3ImageViewer";
import OwTitle from "../OwTitle/OwTitle";
import OwButton from "../OwButton/OwButton";

type Props = {
    closeModalFn: () => void;
    shipmentGroup: IShipment_GroupUI;
};

export const ViewSignatureModal = (props: Props) => {
    const closeModal = () => {
        props.closeModalFn();
    };

    return (
        <div className={"ViewSignatureModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-signature"} title={"view_signature"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div className={"mt-4"}>
                {props.shipmentGroup.Pickup_Signature ? (
                    <div>
                        <img
                            src={props.shipmentGroup.Pickup_Signature?.signedUrl}
                            style={{ width: "100%", height: "100%", maxHeight: "500px" }}
                        />
                    </div>
                ) : null}
                <div>{props.shipmentGroup.pickup_signature}</div>
                <div>
                    <OwLabel title={props.shipmentGroup.is_local_delivery ? "delivered" : "picked_up"} postText={":"} className={"me-2"} />
                    {UserService.parseLastUpdated(props.shipmentGroup.signature_date || "", true)}
                </div>
                {props.shipmentGroup.pickup_signature?.length ? (
                    <div className={"signatureRow"}>
                        <div className={"xStart"}>X</div>
                        <div className={"name"}>{props.shipmentGroup.pickup_signature}</div>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default ViewSignatureModal;
